import { Component, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';


@Component({
  selector: 'app-UserError',
  templateUrl: './UserError.component.html',
  styleUrls: ['./UserError.component.scss']
})
export class UserErrorComponent implements OnInit {

  Token:String=""
  Selected_User_Id:String="0"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
  ) { }


  DataList_User:Array<General_Interface>=[]


  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,2213).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }



  ReadData_User(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.User_Service.GetError(this.Token,StartSearchDate,EndSearchDate).subscribe(
      data=>{
        this.DataList_User=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }
}
